export function normalizeStringForComparison(str: string): string {
  return str.toLowerCase().replace(/\s+/g, '');
}
